export const hasNumber = (str: string) => /\d/.test(str);

export const hasLetter = (str: string) => /[a-zA-Z]/g.test(str);

export const hasSpecialCharacter = (str: string) =>
  /[ `!@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/.test(str);

export const isValidPassword = (str: string) => {
  return (
    str.length >= 8 &&
    hasLetter(str) &&
    hasNumber(str) &&
    hasSpecialCharacter(str)
  );
};

export const isValidEmail = (str: string) => {
  const emailRegex = /[\w-+]+([.]\w+)?@[\w-+]+([.][a-z]{2,})+/;
  return emailRegex.test(String(str).toLowerCase());
};
